<template>
  <!-- VGM编辑  -->
  <div class="page-container">
    <el-form
      :model="ebCtnForm"
      ref="ruleFormRef"
      :rules="rulesForm"
      class="form-panel"
      label-position="top"
    >
      <el-col :span="24">

        <!-- 基本信息-start -->
        <div>
      <!--      <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">基本信息</span>
                </el-col>
                </div>
          </el-row> -->
          <el-row class="content-panel top-radius">
       <div style="margin-bottom:10px">
          <el-button type="primary" size="mini" class="el-button-search">根据提单号获取VGM信息</el-button>
        </div>
            <el-col>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="提单号:">
                    <el-input size="mini" v-model="ebOrderForm.mblNo"
                    :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="船公司:">
                    <el-associate
                      style="width: 100%;"
                      :columns="associate_columns_carrier"
                      :query-method="associate_queryMethod_carrier"
                      class="input_length"
                      clearable
                      case="upper"
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="custAlias"
                      value-prop="carrierId"
                      placeholder=""
                      :disabled="true"
                      v-model="ebOrderForm.carrierName"
                      :title="ebOrderForm.carrierName"
                      size="mini"
                      @change="onChangeCarrier"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-row>
                    <el-col :span="16">
                      <el-form-item label="大船船名/航次:">
                        <el-associate
                          style="width: 100%;"
                          :columns="associate_columns_vessel"
                          :query-method="associate_queryMethod_vessel"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="vesselName"
                          value-prop="vesselId"
                          placeholder=""
                          :disabled="true"
                          v-model="ebOrderForm.vesselNameEn"
                          :title="ebOrderForm.vesselNameEn"
                          size="mini"
                          @change="onChangeVessel"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item>
                        <label slot="label" class="label_no"></label>
                        <el-associate
                          style="width: 100%;"
                          :columns="associate_columns_voyage"
                          :query-method="associate_queryMethod_voyage"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="voyage"
                          value-prop="voyage"
                          :disabled="true"
                          placeholder=""
                          v-model="ebOrderForm.voyage"
                          :title="ebOrderForm.voyage"
                          size="mini"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="装货港:">
                    <el-associate
                      style="width: 100%;"
                      :columns="associate_columns_po"
                      :query-method="associate_queryMethod_po"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="portNameEn"
                      value-prop="portNameEn"
                      placeholder=""
                      v-model="ebOrderForm.polName"
                      :title="ebOrderForm.polName"
                      :disabled="true"
                      size="mini"
                      @change="onChangePol"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <div v-show="moreInfoVisible">
              <el-col style="margin-top:8px;">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="订舱联系人:">
                      <el-input size="mini" v-model="bookingForm.contacts" :title="bookingForm.contacts"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="订舱联系人电话:">
                      <el-input size="mini" v-model="bookingForm.contact_number" :title="bookingForm.contact_number"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="订舱联系人邮箱:">
                      <el-input size="mini" v-model="bookingForm.email" :title="bookingForm.email"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="订舱联系人:">
                      <el-input size="mini" v-model="bookingForm.contacts" :title="bookingForm.contacts"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="订舱联系人电话:">
                      <el-input size="mini" v-model="bookingForm.contact_number" :title="bookingForm.contact_number"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="订舱联系人邮箱:">
                      <el-input size="mini" v-model="bookingForm.email" :title="bookingForm.email"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </div>
          </el-row>
        </div>

        <!-- 基本信息-end -->
        <!-- 箱信息-start -->
          <el-row class="panel-top">
            <el-col>
                <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">箱信息</span>
                </el-col>
                </div>
             </el-row>
              <el-row class="content-panel no-padding">
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="13">
                      <el-row class="content-panel">
                        <el-col>
                        <span class="vgm-title">箱信息</span>
                        <!-- 按钮栏-start -->
                        <el-row style="margin-top:10px">
                          <el-button
                            type="primary"
                            size="small"
                            plain
                            @click="addNewRow"
                            :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                          >新增
                          </el-button>
                          <el-button
                            type="primary"
                            size="small"
                            plain
                            @click="itsmTableCountSelect"
                            :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                          >
                            复制VGM责任人信息
                          </el-button>
                          <el-button
                            type="danger"
                            size="small"
                            plain
                            @click="batchDelete"
                            :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                          >批量删除
                          </el-button>
                        </el-row>
                        <!-- 按钮栏-end -->
                        <!-- 表格-start -->
                        <el-row style="margin-top: 10px">
                          <hot-table
                            ref="ebCtnTableRef"
                            :data-source="ebCtnTableDataSource"
                            :settings="ebCtnTableSettings"
                            col-settings-key="ebCtn"
                            :rules="ebCtnRules"
                            @cellClick="billCargoInfoTableCellClick"
                            @rowClick="rowClick"
                            :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                          >
                            <hot-column
                              :has-tip="true"
                              data="ctnNo"
                              title="箱号"
                              width="150"
                            >
                              <el-associate-editor
                                hot-editor
                                :allow-create="true"
                                style="width: 100%"
                                :columns="associate_columns_ctnNo"
                                :query-method="associate_queryMethod_ctnNo"
                                class="input_length"
                                clearable
                                :default-first-option="true"
                                label-prop="ctnNo"
                                value-prop="ctnNo"
                                placeholder=""
                                size="small"
                                name="ctnNo"
                                @change="ctnNoChange"
                                disabled="true"
                              />
                            </hot-column>
                            <hot-column
                              type="numeric"
                              :numericFormat="{
                              pattern: '0,0.000',
                              culture: 'zh-CN',
                            }"
                              :has-tip="true"
                              data="vgmWeight"
                              title="箱总重"
                              width="150"
                            >
                              <el-input-number-editor
                                :controls="false"
                                :precision="3"
                                :min="0"
                                hot-editor
                                case="upper"
                                data="vgmWeight"
                              />
                            </hot-column>
<!--                            <hot-column-->
<!--                              :has-tip="true"-->
<!--                              data="sealNo"-->
<!--                              title="铅号"-->
<!--                              width="150"-->
<!--                            >-->
<!--                              <el-input-editor-->
<!--                                case="upper"-->
<!--                                hot-editor-->
<!--                                data="sealNo"-->
<!--                              />-->
<!--                            </hot-column>-->
<!--                            <hot-column-->
<!--                              :has-tip="true"-->
<!--                              data="ctnSizeType"-->
<!--                              title="箱型尺寸"-->
<!--                              width="150"-->
<!--                            >-->
<!--                              <el-associate-editor-->
<!--                                hot-editor-->
<!--                                style="width: 100%"-->
<!--                                :columns="associate_columns_ctnSizeType"-->
<!--                                :query-method="associate_queryMethod_ctnSizeType"-->
<!--                                class="input_length"-->
<!--                                clearable-->
<!--                                :query-length="0"-->
<!--                                :default-first-option="true"-->
<!--                                label-prop="containerType"-->
<!--                                value-prop="containerType"-->
<!--                                placeholder=""-->
<!--                                size="small"-->
<!--                                name="ctnSizeType"-->
<!--                                case="upper"-->
<!--                              />-->
<!--                            </hot-column>-->
                            <hot-column
                              :has-tip="true"
                              data="vgmVerifyType"
                              title="称重方式"
                              width="150"
                            >
                              <el-select-editor
                                name="vgmVerifyTypeCn"
                                hot-editor
                                @change="changeVgmVerifyType"
                              >
                                <el-option
                                  v-for="item in vgmVerifyTypeOptions"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.value"
                                >
                                </el-option>
                              </el-select-editor>
                            </hot-column>
                            <hot-column
                              type="numeric"
                              :numericFormat="{
                              pattern: '0,0.000',
                              culture: 'zh-CN',
                            }"
                              :has-tip="true"
                              data="grossWeight"
                              title="毛重"
                              width="150"
                            >
                              <el-input-number-editor
                                :controls="false"
                                :precision="3"
                                :min="0"
                                hot-editor
                                case="upper"
                                data="grossWeight"
                              />
                            </hot-column>
                            <hot-column
                              type="numeric"
                              :numericFormat="{
                              pattern: '0,0.000',
                              culture: 'zh-CN',
                            }"
                              :has-tip="true"
                              data="vgmTareWeight"
                              title="箱皮重"
                              width="150"
                            >
                              <el-input-number-editor
                                :controls="false"
                                :precision="3"
                                :min="0"
                                hot-editor
                                case="upper"
                                data="vgmTareWeight"
                              />
                            </hot-column>
                          </hot-table>
                        </el-row>
                        <!-- 表格-end -->
                        <el-col style="height: 5px"></el-col>
                        </el-col>
                      </el-row>
                    </el-col>
                    <!-- 箱信息-end -->
                    <!-- VGM信息 -->
                  <el-col :span="0.1">
                    <div style="height:400px;width:1px;background:#F0F0F0"></div>
                  </el-col>
                    <el-col :span="10">
                      <el-row class="content-panel" span="12">
                        <span class="vgm-title">VGM称重/授权联系人</span>
                        <el-col style="height: 10px"></el-col>
                        <el-col :span="24">
                          <el-row class="content-panel no-padding  no-margin" span="12">
                            <!-- begin -->
                            <!-- <el-row class="content-panel no-padding"> -->
                              <el-col>
                                <el-row :gutter="10">
                                  <el-col :span="4" style="width: 30%">
                                    <el-form-item
                                      label="称重单位:"
                                      prop="vgmVerifyCompanyName"
                                    >
                                      <el-input
                                        case="upper"
                                        size="mini"
                                        v-model="ebCtnForm.vgmVerifyCompanyName"
                                        :title="ebCtnForm.vgmVerifyCompanyName"
                                        :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                        ref="vgmVerifyCompanyName"
                                      >
                                      </el-input>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :span="4" style="width: 30%">
                                    <el-form-item
                                      label="称重单位负责人:"
                                      vgm_verify_company_resposible_name
                                      prop="vgmVerifyCompanyResposibleName"
                                    >
                                      <el-input
                                        case="upper"
                                        size="mini"
                                        v-model="
                                        ebCtnForm.vgmVerifyCompanyResposibleName"
                                        :title="ebCtnForm.vgmVerifyCompanyResposibleName"
                                        :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                        ref="vgmVerifyCompanyResposibleName"
                                      >
                                      </el-input>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :span="4" style="width: 30%">
                                    <el-form-item
                                      label="联系人:"
                                      prop="vgmVerifyCompanyContact"
                                    >
                                      <el-input
                                        case="upper"
                                        size="mini"
                                        v-model="ebCtnForm.vgmVerifyCompanyContact"
                                        :title="ebCtnForm.vgmVerifyCompanyContact"
                                        :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                        ref="vgmVerifyCompanyContact"
                                      >
                                      </el-input>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :span="4" style="width: 30%">
                                    <el-form-item
                                      label="联系人电话:"
                                      prop="vgmVerifyCompanyContactTel"
                                    >
                                      <el-input
                                        case="upper"
                                        size="mini"
                                        v-model="
                                        ebCtnForm.vgmVerifyCompanyContactTel
                                      "
                                        :title="ebCtnForm.vgmVerifyCompanyContactTel"
                                        :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                         ref="vgmVerifyCompanyContactTel"
                                      >
                                      </el-input>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :span="4" style="width: 30%">
                                    <el-form-item
                                      label="联系人邮箱:"
                                      prop="vgmVerifyCompanyContactEmail"
                                    >
                                      <el-input
                                        case="upper"
                                        size="mini"
                                        v-model="
                                        ebCtnForm.vgmVerifyCompanyContactEmail
                                      "
                                        :title="ebCtnForm.vgmVerifyCompanyContactEmail"
                                        :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                         ref="vgmVerifyCompanyContactEmail"
                                      >
                                      </el-input>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :span="4" style="width: 30%">
                                    <el-form-item
                                      label="称重地点:"
                                      prop="vgmVerifyAddress"
                                    >
                                      <el-input
                                        case="upper"
                                        size="mini"
                                        v-model="
                                        ebCtnForm.vgmVerifyAddress
                                      "
                                        :title="ebCtnForm.vgmVerifyAddress"
                                        :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                         ref="vgmVerifyAddress"
                                      >
                                      </el-input>
                                    </el-form-item>
                                  </el-col>
                                </el-row>
                              </el-col>
                            <!-- </el-row> -->
                          </el-row>
                        </el-col>
                        <!-- VGM称重/授权联系人end -->
                        <el-col :span="24">
                      <el-col style="height: 10px"></el-col>
                   <span class="vgm-title">VGM Shipper</span>
                      <el-col style="height: 10px"></el-col>
                          <el-row class="content-panel no-padding no-margin" span="12">
                            <!--  VGM Shipper begin -->
                            <el-row :gutter="10">
                              <el-col :span="4" style="width: 30%">
                                <el-form-item
                                  label="VGM Shipper:"
                                  prop="vgmShipperName"
                                >
                                  <el-input
                                    case="upper"
                                    size="mini"
                                    v-model="ebCtnForm.vgmShipperName"
                                    :title="ebCtnForm.vgmShipperName"
                                    :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                    ref="vgmShipperName"
                                  >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="4" style="width: 30%">
                                <el-form-item
                                  label="负责人签名:"
                                  prop="vgmResponsiblePersonSign"
                                >
                                  <el-input
                                    case="upper"
                                    size="mini"
                                    v-model="ebCtnForm.vgmResponsiblePersonSign"
                                    :title="ebCtnForm.vgmResponsiblePersonSign"
                                    :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                    ref="vgmResponsiblePersonSign"
                                  >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="4" style="width: 30%">
                                <el-form-item
                                  label="负责人:"
                                  prop="vgmResponsiblePerson"
                                >
                                  <el-input
                                    case="upper"
                                    size="mini"
                                    v-model="ebCtnForm.vgmResponsiblePerson"
                                    :title="ebCtnForm.vgmResponsiblePerson"
                                    :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                    ref="vgmResponsiblePerson"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="4" style="width: 30%">
                                <el-form-item
                                  label="联系人:"
                                  prop="vgmFactContactName"
                                >
                                  <el-input
                                    case="upper"
                                    size="mini"
                                    v-model="ebCtnForm.vgmFactContactName"
                                    :title="ebCtnForm.vgmFactContactName"
                                    :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                    ref="vgmFactContactName"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="4" style="width: 30%">
                                <el-form-item
                                  label="联系人电话:"
                                  prop="vgmContactTel"
                                >
                                  <el-input
                                    case="upper"
                                    size="mini"
                                    v-model="ebCtnForm.vgmContactTel"
                                    :title="ebCtnForm.vgmContactTel"
                                    :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                    ref="vgmContactTel"
                                  >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="4" style="width: 30%">
                                <el-form-item
                                  label="联系人邮箱:"
                                  prop="vgmContactEmail"
                                >
                                  <el-input
                                    case="upper"
                                    size="mini"
                                    v-model="ebCtnForm.vgmContactEmail"
                                    :title="ebCtnForm.vgmContactEmail"
                                    :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                    ref="vgmContactEmail"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="4" style="width: 30%">
                                <el-form-item
                                  label="称重日期:"
                                  prop="vgmVerifyDate"
                                  date-format="YYYY-MM-DD"
                                >
                                  <el-date-picker
                                    v-model="ebCtnForm.vgmVerifyDate"
                                    align="right"
                                    type="date"
                                    style="width: 100%"
                                    size="mini"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    placeholder=""
                                    default-time="00:00:00"
                                    :picker-options="pickerOptions"
                                    :disabled="ebOrderForm.vgmApprovalStatus === 'SUB' || ebOrderForm.vgmApprovalStatus === 'CRM'"
                                    ref="vgmVerifyDate"
                                  >
                                  </el-date-picker>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-row>
                        </el-col>
                        <!-- VGM Shipper end -->
                        <!-- <el-col style="height:5px"></el-col> -->
                      </el-row>
                    </el-col>
                  </el-row>
                   <div style="text-align:end;padding:0 20px 20px 0">
                  <el-button
                    type="primary"
                    size="mini"
                    :disabled="isAbleOne"
                    @click="saveAllCtn"
                    v-if="!isAbleOne"
                  >暂存草稿
                  </el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    :disabled="isAble"
                    v-if="!isAble"
                    @click="sumbitInfo"
                  >提交
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="changeHistoryBox"
                    v-preventReClick
                  >修改历史
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    v-if="!isAbleOnCancel"
                    @click="cancelSubmit"
                  >撤销提交
                  </el-button>
                  <el-button type="primary" size="mini" @click="closeTab">关闭</el-button>
                 </div>
                </el-col>
              </el-row>
            </el-col>

          </el-row>
        <!-- 箱信息-end -->
      </el-col>

    </el-form>
    <change_history_box
      :change-history-visible-flag-init="changeHistoryBoxVisible"
      :ebOrder="ebOrderForm"
    />
  </div>
</template>

<script>
import ebCtn from "@/api/ebCtn";
import {queryCarrierInfo, queryCtnSizeInfo, queryDictRows, queryPoInfo, queryVoyageInfo,} from "@/api/commonService";

import {
  batchDeleteEbOrder,
  judgeWhetherDeleteEbCtns,
  queryByVgmOrderId,
  queryCtnByVgmOrderId,
  saveEbCtnAdDradt,
} from "@/api/vgmManage";
import {getEbServiceItem, publicSubmit, revokeSub} from "@/api/bookingRequest";
import autoFocusMixin from "@/mixin/autoFocus"
import changeHistoryBox from "@/views/booking/ReviseHistoryBox";

export default {
  name: "VGMEdit",
  components: {
    change_history_box: changeHistoryBox,
  },
  mixins: [autoFocusMixin],
  data() {
    return {
      vgmVerifyTypeOptions: [],
      submitVisible: true,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      //收货地/装货港/中转港/卸货港/交货地联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      // 船公司
      associate_columns_carrier: [
        {
          title: "客商简称",
          field: "custAlias",
        },
        {
          title: "中文全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      //大船/驳船船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      //航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
      //箱号联想控件
      associate_columns_ctnNo: [
        {
          title: "箱号",
          field: "ctnNo",
        },
      ],
      //箱型联想控件
      associate_columns_ctnSizeType: [
        {
          title: "箱型尺寸",
          field: "containerType",
        },
      ],
      boxVisible: true,
      moreInfoVisible: false,
      changeHistoryBoxVisible: false,
      ebOrderForm: {
        ebOrderId: "",
        mblNo: "",
        carrierName: "",
        vesselNameEn: "",
        voyage: "",
        polName: "",
        vgmVerifyDate: "",
      },
      ebServiceItems: [],
      readonly: true,
      ebCtnForm: {
        vgmVerifyCompanyResposibleName: "",
        vgmVerifyCompanyContact: "",
        vgmVerifyCompanyContactTel: "",
        vgmVerifyCompanyContactEamil: "",
        vgmShipperName: "",
        vgmResponsiblePerson: "",
        vgmResponsiblePersonSign: "",
        vgmFactContactName: "",
        vgmContactTel: "",
        vgmContactEmail: "",
        ebOrderId: "",
        vgmVerifyCompanyName: "",
      },
      rulesForm: {
        vgmVerifyCompanyName: [
          {
            required: false,
            message: "称重单位不能为空",
            trigger: ["blur", "change"],
          },
        ],
        vgmVerifyCompanyResposibleName: [
          {
            required: false,
            message: "称重单位负责人不能为空",
            trigger: ["blur", "change"],
          },
        ],
        vgmVerifyCompanyContact: [
          {
            required: false,
            message: "联系人不能为空",
            trigger: ["blur", "change"],
          },
        ],
        vgmVerifyCompanyContactTel: [
          {
            required: false,
            message: "联系人电话不能为空",
            trigger: ["blur", "change"],
          },
        ],
        vgmVerifyCompanyContactEmail: [
          {
            required: false,
            message: "联系人邮箱不能为空",
            trigger: ["blur", "change"],
          },
        ],
        vgmShipperName: [
          {
            required: false,
            message: "VGM Shipper不能为空",
            trigger: ["blur", "change"],
          },
        ],
        vgmResponsiblePerson: [
          {
            required: false,
            message: "负责人不能为空",
            trigger: ["blur", "change"],
          },
        ],
        vgmResponsiblePersonSign: [
          {
            required: false,
            message: "负责人签名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        vgmFactContactName: [
          {
            required: false,
            message: "联系人不能为空",
            trigger: ["blur", "change"],
          },
        ],
        vgmContactTel: [
          {
            required: false,
            message: "联系人电话不能为空",
            trigger: ["blur", "change"],
          },
        ],
        vgmContactEmail: [
          {
            required: false,
            message: "联系人邮箱不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      manifestAddForm: {},
      bookingForm: {
        bookingNum: "",
        customerbusiness_num: "",
        bill_lading_num: "",
        payType: "",
        payer: "",
        pay_place: "",
        clause: "",
        sc: "",
        na: "",
        signing_method: "",
        signing_place: "",
        copies_chief: "",
        copies_deputy: "",
        contacts: "",
        contact_number: "",
        email: "",
        checkList: [],
        etd: "",
        customerNotes: "",
        feedbackNotes: "",
      },
      ebOrderInfoAndEbCtnInfo: {
        ebCtn: [],
        ebOrderId: "",
      },
      // 表格校验
      ebCtnRules: {},

      //tab状态栏
      activeName: 0,
      ebCtnFormRow: 0,
      // 表格数据
      ebCtnTableDataSource: [],
      // 表格设置
      ebCtnTableSettings: {
        height: 305,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        afterChange: this.afterChangeMe,
        ...this.$systemConfig.tableConfig,
      },
      cargoInfoForm: {
        checkList: [],
        shippingMark: "父向子传值", //唛头
        cargoDetail: "", //货物描述
        pieces: "",
        package: "",
        grossWeight: "", //毛重
        volume: "", //体积
        netWeight: "", //净重
        hsCode: "",
        cargoInfoArr: [0],
      },
      ctnNoRepeat: false,
      isAble: false,
      isAbleOne: false,
      isAblepolName: false,
      isAbleOnCancel: false
    };
  },
  async created() {
    let self = this;
    self.ebOrderId = self.$route.params.ebOrderId;
    if (self.ebOrderId !== null && self.ebOrderId !== undefined && self.ebOrderId !== "") {
      self.initPage();
    }
  },
  mounted() {
    let _this = this;
    _this.getSelectList();
    //根据ebOrderId获取ebServiceItems
    if(_this.ebOrderId !== null && _this.ebOrderId !== undefined && _this.ebOrderId !== ""){
      _this.getEbServiceItem(_this.$route.params.ebOrderId).then(res => {
        let ebServiceItems = JSON.parse(JSON.stringify(res));
        _this.ebServiceItems = ebServiceItems;
      });
    }
  },
  activated() {
    let self = this;
    self.ebOrderId = self.$route.params.ebOrderId;
    if(self.ebOrderId) self.initPage()
  },
  methods: {
    initPage() {
      let self = this;
      queryByVgmOrderId(self.ebOrderId).then((res) => {
        if (res != null) {
          self.ebOrderForm.mblNo = res.data.mblNo;
          self.ebOrderForm.carrierName = res.data.carrierName;
          self.ebOrderForm.vesselNameEn = res.data.vesselNameEn;
          self.ebOrderForm.voyage = res.data.voyage;
          self.ebOrderForm.polName = res.data.polName;
          self.ebOrderForm.polCode = res.data.polCode;
          self.ebOrderForm.ebOrderId = res.data.ebOrderId;
          self.ebOrderForm = res.data
          //判断vgmApproalStatus是否为草稿状态
        }
        if (res.data.vgmApprovalStatus != "CRM") {
          // 装货港联想置灰
          self.isAblepolName = true;
        }
        if (res.data.vgmApprovalStatus != "NEW" && res.data.vgmApprovalStatus != "REJ") {
          //提交按钮置灰
          self.isAble = true;
          //暂存草稿置灰
          self.isAbleOne = true;
        }
        if (res.data.vgmApprovalStatus != "SUB") {
          //撤销提交显示
          self.isAbleOnCancel = true;
        }
      });
      queryCtnByVgmOrderId(self.ebOrderId).then((res) => {
        if (res != null) {
          self.ebCtnTableDataSource = res.data;
          self.ebCtnTableDataSource.forEach(function (item) {
            if(item.vgmVerifyType===0){
              item.vgmVerifyType='整体称重(M1)';
            };if(item.vgmVerifyType===1){
              item.vgmVerifyType='累加法(M2)';
            };
          });
          if(res.data.length > 0) {
            self.ebCtnForm = res.data[0];
            self.lineHighlight(1);
          }

        }
      });
    },
    changeHistoryBox() {
      this.changeHistoryBoxVisible = !this.changeHistoryBoxVisible;
    },
    /**
     * 箱信息行高亮
     */
    lineHighlight(number) {
      let self = this;
      self.$refs.ebCtnTableRef.hotInstance.addHookOnce(
        "afterLoadData",
        function () {
          self.$nextTick(function () {
            self.$refs.ebCtnTableRef.hotInstance.selectCell(number - 1, 1);
          });
        }
      );
    },
    ctnNoChange(value, selectedRow) {
      let self = this;
      let hotInstance = self.$refs.ebCtnTableRef.hotInstance;
      console.log(value);
      let target = this.ebCtnTableDataSource.find(
        (item) => item.ctnNo === value
      );
      if (target) {
        self.$coreMethods.message("warning", "箱号" + value + "重复，请检查");
        hotInstance.setDataAtRowProp(
          self.ebCtnFormRow,
          'ctnNo',
          null
        );
      }
    },
    // 获取数据字典
    getSelectList() {
      queryDictRows("MD_CODE_DICT$VGM_VERIFY_TYPE").then((res) => {
        /*name:value value:key*/
        //称重方式
        this.vgmVerifyTypeOptions = res.MD_CODE_DICT$VGM_VERIFY_TYPE;
        this.setDictionaries();
      });
    },
    //数据字典
    setDictionaries() {
      let dict = [];
      this.vgmVerifyTypeOptions.forEach((item) => {
        let param = {};
        param.name = item.label;
        param.value = item.value;
        param.count = 0;
        dict.push(param);
      });
      this.$hotTableUtils.registDict({ EB_CTN_VGM_VERIFY_TYPE: dict });
    },
    // 箱号联想控件数据源
    associate_queryMethod_ctnNo({ keyword, pageSize, currentPage }) {
      let self = this;
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        ctnNo: keyword,
        ebOrderId: self.ebOrderForm.ebOrderId
        // ebOrderId: this.ebFtPlanEditForm.ebOrder.ebOrderId,
      };

      return new Promise((resolve) => {
        ebCtn.getEbCtn(params).then((res) => {
          resolve({
            records: res.data,
            total: res.data.length,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 箱型尺寸联想控件数据源
    associate_queryMethod_ctnSizeType({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
          isActive: "1",
        };
      } else {
        params = {
          isDeleted0: "%" + keyword + "%",
          containerType1: "%" + keyword + "%",
          isDeleted2: "0",
          isActive: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdContainerType.containerType"],
        mainModelName: "CTS_ILPMdContainerType",
        tag: "CTS_ILP_es",
        where:
          "((CTS_ILPMdContainerType.isDeleted LIKE :isDeleted0 OR CTS_ILPMdContainerType.containerType LIKE :containerType1) AND CTS_ILPMdContainerType.isDeleted = :isDeleted2 AND CTS_ILPMdContainerType.isActive = :isActive)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdContainerType.mdContainerTypeId",
          "CTS_ILPMdContainerType.containerTypeName",
          "CTS_ILPMdContainerType.recordVersion",
          "CTS_ILPMdContainerType.ctnHeight",
          "CTS_ILPMdContainerType.principalGroupCode",
          "CTS_ILPMdContainerType.lastModifierId",
          "CTS_ILPMdContainerType.ctnWeight",
          "CTS_ILPMdContainerType.lastModifyOffice",
          "CTS_ILPMdContainerType.creatorName",
          "CTS_ILPMdContainerType.createOffice",
          "CTS_ILPMdContainerType.teu",
          "CTS_ILPMdContainerType.isActive",
          "CTS_ILPMdContainerType.creatorId",
          "CTS_ILPMdContainerType.createTime",
          "CTS_ILPMdContainerType.lastModifyOfficeName",
          "CTS_ILPMdContainerType.ctnWidth",
          "CTS_ILPMdContainerType.containerSize",
          "CTS_ILPMdContainerType.lastModifyTime",
          "CTS_ILPMdContainerType.ctnDescriptionEn",
          "CTS_ILPMdContainerType.ctnDescriptionCn",
          "CTS_ILPMdContainerType.maxWeight",
          "CTS_ILPMdContainerType.containerType",
          "CTS_ILPMdContainerType.ctnLength",
          "CTS_ILPMdContainerType.lastModifierName",
          "CTS_ILPMdContainerType.isDeleted",
          "CTS_ILPMdContainerType.appCode",
          "CTS_ILPMdContainerType.maxMeas",
          "CTS_ILPMdContainerType.reamrk",
          "CTS_ILPMdContainerType.createOfficeName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCtnSizeInfo(data).then((res) => {
          console.log("queryCtnSizeInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    changeVgmVerifyType(value) {
      console.log(value);
      /*this.vgmVerifyTypeOptions.forEach((item) => {
        if (item["value"] === value) {
          if(value==='整体称重(M1)') {
            this.rulesForm = {
              vgmVerifyCompanyName: [
                {
                  required: true,
                  message: "称重单位不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmVerifyCompanyResposibleName: [
                {
                  required: true,
                  message: "称重单位负责人不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmVerifyCompanyContact: [
                {
                  required: true,
                  message: "联系人不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmVerifyCompanyContactTel: [
                {
                  required: true,
                  message: "联系人电话不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmVerifyCompanyContactEmail: [
                {
                  required: true,
                  message: "联系人邮箱不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmShipperName: [
                {
                  required: false,
                  message: "VGM Shipper不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmResponsiblePerson: [
                {
                  required: false,
                  message: "负责人不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmResponsiblePersonSign: [
                {
                  required: false,
                  message: "负责人签名不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmFactContactName: [
                {
                  required: false,
                  message: "联系人不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmContactTel: [
                {
                  required: false,
                  message: "联系人电话不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmContactEmail: [
                {
                  required: false,
                  message: "联系人邮箱不能为空",
                  trigger: ["blur", "change"],
                },
              ],
            }
          };
          if(value==='累加法(M2)'){
            this.rulesForm={
              vgmVerifyCompanyName: [
                {
                  required: false,
                  message: "称重单位不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmVerifyCompanyResposibleName: [
                {
                  required: false,
                  message: "称重单位负责人不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmVerifyCompanyContact: [
                {
                  required: false,
                  message: "联系人不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmVerifyCompanyContactTel: [
                {
                  required: false,
                  message: "联系人电话不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmVerifyCompanyContactEmail: [
                {
                  required: false,
                  message: "联系人邮箱不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmShipperName: [
                {
                  required: true,
                  message: "VGM Shipper不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmResponsiblePerson: [
                {
                  required: true,
                  message: "负责人不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmResponsiblePersonSign: [
                {
                  required: true,
                  message: "负责人签名不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmFactContactName: [
                {
                  required: true,
                  message: "联系人不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmContactTel: [
                {
                  required: true,
                  message: "联系人电话不能为空",
                  trigger: ["blur", "change"],
                },
              ],
              vgmContactEmail: [
                {
                  required: true,
                  message: "联系人邮箱不能为空",
                  trigger: ["blur", "change"],
                },
              ],
            }
          };
          self.$refs.ebCtnTableRef.hotInstance.validateColumns(
            [1, 4, 5],
            (valid) => {
              if (valid) {
                self.$refs.ruleFormRef.validate((valid) => {
                  if (!valid) {
                  }
                });
              } else {
              }
            }
          );
          console.log('11');
        }
      });*/
    },
    // 获取货物信息组件中的数据
    getCargoInfo(value) {
      console.log("货物信息组件数据：", value);
    },
    //预配箱信息单元格点击事件
    boxInfoTableCellClick() {
    },
    //预配箱信息单击行事件
    boxInfoTableRowClick() {
    },
    //新增行
    addNewRow() {
      let self = this;
      let newRow = [
        {
          rowStatus: 4, // 新增行状态值为4，修改行状态值为16
          isDeleted: 0,
          isset: true,
        },
      ];
      self.rulesForm= {
        vgmVerifyCompanyName: [
          {
            required: false,
            message: "称重单位不能为空",
            trigger: ["blur", "change"],
          },
        ],
          vgmVerifyCompanyResposibleName: [
          {
            required: false,
            message: "称重单位负责人不能为空",
            trigger: ["blur", "change"],
          },
        ],
          vgmVerifyCompanyContact: [
          {
            required: false,
            message: "联系人不能为空",
            trigger: ["blur", "change"],
          },
        ],
          vgmVerifyCompanyContactTel: [
          {
            required: false,
            message: "联系人电话不能为空",
            trigger: ["blur", "change"],
          },
        ],
          vgmVerifyCompanyContactEmail: [
          {
            required: false,
            message: "联系人邮箱不能为空",
            trigger: ["blur", "change"],
          },
        ],
          vgmShipperName: [
          {
            required: false,
            message: "VGM Shipper不能为空",
            trigger: ["blur", "change"],
          },
        ],
          vgmResponsiblePerson: [
          {
            required: false,
            message: "负责人不能为空",
            trigger: ["blur", "change"],
          },
        ],
          vgmResponsiblePersonSign: [
          {
            required: false,
            message: "负责人签名不能为空",
            trigger: ["blur", "change"],
          },
        ],
          vgmFactContactName: [
          {
            required: false,
            message: "联系人不能为空",
            trigger: ["blur", "change"],
          },
        ],
          vgmContactTel: [
          {
            required: false,
            message: "联系人电话不能为空",
            trigger: ["blur", "change"],
          },
        ],
          vgmContactEmail: [
          {
            required: false,
            message: "联系人邮箱不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      self.ebCtnTableDataSource = newRow.concat(self.ebCtnTableDataSource);
      // 选中第一条高亮显示
      self.$refs.ebCtnTableRef.hotInstance.addHookOnce(
        "afterLoadData",
        function () {
          self.$nextTick(function () {
            self.$refs.ebCtnTableRef.hotInstance.selectCell(0, 1);
          });
        }
      );
    },
    billCargoInfoTableCellClick(row) {
      this.$refs.ebCtnTableRef.startEdit(row.physicalRow, row.physicalCol);
    },
    //单击行事件
    rowClick(val) {
      let self = this;
      self.ebCtnForm = val.record;
      /*if(self.ebCtnForm.vgmVerifyType==='整体称重(M1)'){
        this.rulesForm= {
          vgmVerifyCompanyName: [
            {
              required: true,
              message: "称重单位不能为空",
              trigger: ["blur", "change"],
            },
          ],
            vgmVerifyCompanyResposibleName: [
            {
              required: true,
              message: "称重单位负责人不能为空",
              trigger: ["blur", "change"],
            },
          ],
            vgmVerifyCompanyContact: [
            {
              required: true,
              message: "联系人不能为空",
              trigger: ["blur", "change"],
            },
          ],
            vgmVerifyCompanyContactTel: [
            {
              required: true,
              message: "联系人电话不能为空",
              trigger: ["blur", "change"],
            },
          ],
            vgmVerifyCompanyContactEmail: [
            {
              required: true,
              message: "联系人邮箱不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmShipperName: [
            {
              required: false,
              message: "VGM Shipper不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmResponsiblePerson: [
            {
              required: false,
              message: "负责人不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmResponsiblePersonSign: [
            {
              required: false,
              message: "负责人签名不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmFactContactName: [
            {
              required: false,
              message: "联系人不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmContactTel: [
            {
              required: false,
              message: "联系人电话不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmContactEmail: [
            {
              required: false,
              message: "联系人邮箱不能为空",
              trigger: ["blur", "change"],
            },
          ],
        }
      };
      if(self.ebCtnForm.vgmVerifyType==='累加法(M2)'){
        this.rulesForm={
          vgmVerifyCompanyName: [
            {
              required: false,
              message: "称重单位不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmVerifyCompanyResposibleName: [
            {
              required: false,
              message: "称重单位负责人不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmVerifyCompanyContact: [
            {
              required: false,
              message: "联系人不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmVerifyCompanyContactTel: [
            {
              required: false,
              message: "联系人电话不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmVerifyCompanyContactEmail: [
            {
              required: false,
              message: "联系人邮箱不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmShipperName: [
            {
              required: true,
              message: "VGM Shipper不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmResponsiblePerson: [
            {
              required: true,
              message: "负责人不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmResponsiblePersonSign: [
            {
              required: true,
              message: "负责人签名不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmFactContactName: [
            {
              required: true,
              message: "联系人不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmContactTel: [
            {
              required: true,
              message: "联系人电话不能为空",
              trigger: ["blur", "change"],
            },
          ],
          vgmContactEmail: [
            {
              required: true,
              message: "联系人邮箱不能为空",
              trigger: ["blur", "change"],
            },
          ],
        }
      };*/
      self.ebCtnFormRow = val.row
      self.ebCtnForm.ebOrderId = self.$route.params.ebOrderId;
      self.$refs.ebCtnTableRef.hotInstance.validateColumns(
        [1, 4, 5],
        (valid) => {
          if (valid) {
            self.$refs.ruleFormRef.validate((valid) => {
              if (!valid) {
              }
            });
          } else {
          }
        }
      );
    },
    // 修改表格后事件
    afterChangeMe(change, source) {
      console.log("change", change);
      let self = this;

      if (change != null) {
        if (
          change[0][1] !== "$$checked" &&
          change[0][2] !== change[0][3] &&
          this.ebCtnTableDataSource[change[0][0]].rowStatus !== 4
        ) {
          self.ebCtnTableDataSource[change[0][0]].rowStatus = 16;
          console.log("修改行", this.ebCtnTableDataSource[change[0][0]]);
        }
      }
      //+
      this.$route.meta.verifyValue = false;
      this.$store.dispatch("tagsView/updateVisitedView", this.$route);
    },
    //暂存草稿
    saveAllCtn() {
      let self = this;
      //必输字段校验
      self.$refs.ebCtnTableRef.hotInstance.validateColumns(
        [1, 4, 5],
        (valid) => {
          if (valid) {
            self.$refs.ruleFormRef.validate((valid) => {
              if (valid) {
                self.ebCtnTableDataSource.forEach(function (item) {
                  if(item.vgmVerifyType==='整体称重(M1)'){
                    item.vgmVerifyType=0;
                  };if(item.vgmVerifyType==='累加法(M2)'){
                    item.vgmVerifyType=1;
                  };
                });
                //将ebOrder表mblNo赋值给b_ctn中broker_mbl_no
                self.ebCtnTableDataSource.forEach(item => {
                  item.brokerMblNo = self.ebOrderForm.mblNo;
                  item.settleOfficeName = self.ebOrderForm.settleOfficeName;
                  item.settleOffice = self.ebOrderForm.settleOffice;
                });
                //保存至eb_ctn表
                saveEbCtnAdDradt(self.ebCtnTableDataSource).then((res) => {
                  if (res.success) {
                    self.ebOrderId = self.$route.params.ebOrderId;
                    self.$coreMethods.message("success", "暂存草稿成功！");
                    queryCtnByVgmOrderId(self.ebOrderId).then((res) => {
                      if (res != null) {
                        res.data.forEach(function (item) {
                          if(item.vgmVerifyType===0){
                            item.vgmVerifyType='整体称重(M1)';
                          };if(item.vgmVerifyType===1){
                            item.vgmVerifyType='累加法(M2)';
                          };
                        });
                        self.ebCtnTableDataSource=res.data;
                      }
                    });
                  } else {
                    self.$coreMethods.message("error", "暂存草稿失败！");
                  }
                });
              }
              else {
                self.validateAutoFocus();
                self.$coreMethods.message("warning", "请检查必输字段！");
              }
            });
          } else {
            self.$coreMethods.message("warning", "请检查必输字段！");
          }
        }
      );
    },
    validateAutoFocus() {
      this.autoFocus(this.ebCtnForm, this.rulesForm);
    },
    getEbServiceItem(id) {
      let data = {
        ebOrderId: id
      }
      return getEbServiceItem(data)
    },
    //提交到主系统
    sumbitInfo() {
      let self = this;
      self.ebOrderForm.urgentLevel = "N";
      let data = {
        dataType: "VGM",
        ebOrderDTO: self.ebOrderForm,
        type: "web",
      };
      self.ebCtnTableDataSource.forEach(function (item) {
        delete item.vgmVerifyType;
      });
      data.ebOrderDTO.ebCtns = self.ebCtnTableDataSource;
      data.ebOrderDTO.ebCtns.forEach(item =>{
        item.settleOfficeName = self.ebOrderForm.settleOfficeName;
        item.settleOffice = self.ebOrderForm.settleOffice;
      });
      //必输字段校验
      self.$refs.ebCtnTableRef.hotInstance.validateColumns(
        [1, 4, 5],
        (valid) => {
          if (valid) {
            self.$refs.ruleFormRef.validate((valid) => {
              if (valid) {
                let userInfo = JSON.parse(localStorage.getItem("userInfo"));
                data.ebOrderDTO.submitPersonId = userInfo.userId;
                data.ebOrderDTO.submitPerson = userInfo.userNameCn;
                data.ebOrderDTO.vgmStatus ='NST'
                data.ebOrderDTO.ebServiceItems = self.ebServiceItems;
                if (data.ebOrderDTO.ebOrderStatus === "BKCONFIRM"){
                  //将ebOrder表mblNo赋值给eb_ctn中broker_mbl_no
                  self.ebCtnTableDataSource.forEach(item => {
                    item.brokerMblNo = self.ebOrderForm.mblNo;
                    item.settleOfficeName = self.ebOrderForm.settleOfficeName;
                    item.settleOffice = self.ebOrderForm.settleOffice;
                  });

                  //保存至eb_ctn表
                  saveEbCtnAdDradt(self.ebCtnTableDataSource).then((res) => {
                    if (res.success) {
                      self.ebOrderId = self.$route.params.ebOrderId;
                      //提交给主系统
                      publicSubmit(data).then((res) => {
                        if (res.success) {
                          self.$coreMethods.message("success", "提交成功");
                          //关闭并跳转
                          self.$store
                            .dispatch("tagsView/delView", self.$route)
                            .then(() => {
                              self.$nextTick(() => {
                                self.$router.push({ name: "VGMManage" });
                              });
                            });
                        } else {
                          self.$coreMethods.message("error", "提交失败");
                        }
                      });
                    } else {
                      self.$coreMethods.message("error", "提交失败！");
                    }
                  });
                } else {
                  self.$coreMethods.message("warning", "请选择订舱成功的数据！");
                }
              } else {
                self.$coreMethods.message("warning", "请检查必输字段！");
              }
            });
          } else {
            self.$coreMethods.message("warning", "请检查必输字段！");
          }
        }
      );
    },

    //撤销提交
    cancelSubmit() {
      let self = this;
      self.$coreMethods.confirm(
        function () {
          revokeSub({
            ebOrderId: self.ebOrderId,
            dataType: "VGM"
          }).then((res) => {
            if (res.success) {
              self.initPage(self.ebOrderId);
              self.$coreMethods.message("success", "撤销提交成功");
              self.isAble = false;
              self.isAbleOne = false;
            } else {
              self.$coreMethods.message("error", "撤销提交失败");
            }
          });
        },
        function () {
        },
        false,
        "是否执行撤销操作？"
      );
      self.submitVisible = true;
    },
    //VGM复制责任联系人
    itsmTableCountSelect() {
      let self = this;
      //获取勾选行数据
      let params = self.$refs.ebCtnTableRef.getSelections();
      if (params.length > 1) {
        self.$coreMethods.message("warning", "仅选择一条数据");
        return;
      } else if (params.length == 0) {
        self.$coreMethods.message("warning", "当前为选择数据，请选择一条数据");
        return;
      } else if (self.ebCtnTableDataSource.length <= 1) {
        self.$coreMethods.message("warning", "当前无其他数据需要复制VGM联系人");
        return;
      } else if (params.length == 1) {
        //遍历
        let copyValues = params[0];

        self.ebCtnTableDataSource.forEach((item) => {
          item.vgmVerifyCompanyName = copyValues.vgmVerifyCompanyName;
          item.vgmVerifyCompanyContact = copyValues.vgmVerifyCompanyContact;
          item.vgmVerifyCompanyContactEmail =
            copyValues.vgmVerifyCompanyContactEmail;
          item.vgmVerifyCompanyContactTel =
            copyValues.vgmVerifyCompanyContactTel;
          item.vgmVerifyCompanyResposibleName =
            copyValues.vgmVerifyCompanyResposibleName;
          item.vgmShipperName = copyValues.vgmShipperName;
          item.vgmResponsiblePerson = copyValues.vgmResponsiblePerson;
          item.vgmResponsiblePersonSign = copyValues.vgmResponsiblePersonSign;
          item.vgmFactContactName = copyValues.vgmFactContactName;
          item.vgmContactTel = copyValues.vgmContactTel;
          item.vgmContactEmail = copyValues.vgmContactEmail;
          item.vgmVerifyAddress = copyValues.vgmVerifyAddress;
        });

        self.$coreMethods.message("success", "复制VGM联系人成功！");
      }
    },

    // 批量删除
    batchDelete() {
      let self = this;
      let flag = true;
      let ebCtnIds = [];
      let selectEbCtns = [];
      let params = self.$refs.ebCtnTableRef.getSelections();
      // 判断是否有修改数据
      self.ebCtnTableDataSource.forEach((item) => {
        if (item.rowStatus === 16) {
          flag = false;
        }
      });
      //获取选中的ebCtnId
      params.forEach((item) => {
        if (item.rowStatus !== 4) {
          selectEbCtns.push(item.ebCtnId);
        }
      });
      // 存在修改了未保存数据
      if (!flag) {
        self.$coreMethods.message("warning", "数据未保存，请先保存！");
      } else if (params.length !== 0) {
        self.$coreMethods.confirm(
          function () {
            judgeWhetherDeleteEbCtns(selectEbCtns).then((res) => {
              if (res.data == "1") {
                // 删除操作
                params.forEach((item) => {
                  if (item.rowStatus !== 4) {
                    ebCtnIds.push(item.ebCtnId);
                  } else {
                    // 新增-界面删除
                    let index = self.ebCtnTableDataSource.indexOf(item);
                    self.ebCtnTableDataSource.splice(index, 1);
                    self.ebCtnForm = {};
                  }
                });
                if (ebCtnIds.length > 0) {
                  // 既有新增行又有数据库已存数据
                  //批量删除方法
                  batchDeleteEbOrder(ebCtnIds).then(function (res) {
                    if (res.success === undefined) {
                      self.$coreMethods.message("error", res);
                    } else if (res.success) {
                      self.ebOrderId = self.$route.params.ebOrderId;
                      queryCtnByVgmOrderId(self.ebOrderId).then((res) => {
                        if (res != null) {
                          self.ebCtnTableDataSource = res.data;
                        }
                      });
                      self.$coreMethods.message("success", "批量删除成功！");
                    } else {
                      self.$coreMethods.message("error", "批量删除失败！");
                    }
                  });
                }
              }
            });
          },
          function () {
            self.$emit("close");
          },
          false,
          "",
          "删除VGM信息会删除所有关联的箱信息， 是否继续?",
          "error"
        );
      } else if (params.length === 0) {
        self.$coreMethods.message("warning", "请选择要删除的数据！");
      }
      self.$forceUpdate();
    },

    boxInfoFn() {
      this.boxVisible = true;
      let containerWidth =
        document.getElementById("boxDiv").clientWidth - 21.22;
      this.$nextTick(() => {
        this.$refs.boxInfoTableRef.resizeTo(containerWidth);
      });
    },
    //关闭界面并返回上一级页面
    closeTab() {
      this.$store.state.tagsView.visitedViews.splice(
        this.$store.state.tagsView.visitedViews.findIndex(
          (item) => item.path === this.$route.path
        ),
        1
      );
      this.$router.push(
        this.$store.state.tagsView.visitedViews[
        this.$store.state.tagsView.visitedViews.length - 1
          ].path
      );
    },
    boxDetailFn() {
      this.boxVisible = false;
      let containerWidth =
        document.getElementById("boxDiv").clientWidth - 21.22;
      this.$nextTick(() => {
        this.$refs.boxDetailTableRef.resizeTo(containerWidth);
      });
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船公司change
    onChangeCarrier(value, selectedRows) {
      let self = this
      self.ebOrderForm.carrierName = selectedRows.custAlias
      self.ebOrderForm.carrierId = selectedRows.csCustId
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //大船船名联想控件修改事件
    onChangeVessel(value, selectedRows) {
      this.ebOrderForm.vesselId = selectedRows.vesselId;
      this.ebOrderForm.vesselNameEn = selectedRows.vesselName
      this.ebOrderForm.voyage = selectedRows.voyage;
    },
    // 收货地/装货港/中转港/卸货港/交货地联想控件数据源
    associate_queryMethod_po({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //装货港联想控件修改事件
    onChangePol(value, selectedRows) {
      this.ebOrderForm.polId = selectedRows.mdPortId;
      this.ebOrderForm.polCode = selectedRows.portCode;
    },
  },
  beforeDestroy() {
    let _this = this;
    // 离开页面删除检测器和所有侦听器
    _this.resizeObserver.disconnect();
  },
};
</script>

<style scoped lang="less">
</style>
